document.addEventListener('DOMContentLoaded', () => {
  // // #region NumberCounter
  // const counters = document.querySelectorAll(
  //   '.fac-nc-ergebnis .percent .percent-value'
  // )
  // const mObserver = new MutationObserver(records => {
  //   const counter = records[0].target
  //   let locale = 'de-DE'

  //   const numberFormatter = new Intl.NumberFormat(locale, {})

  //   const fullLength = counter.closest('.fac-nc-ergebnis').dataset.numberValue.length
  //   const decimalIndex = counter.closest('.fac-nc-ergebnis').dataset.numberValue.indexOf('.')
  //   const decimalLength = counter.closest('.fac-nc-ergebnis').dataset.numberValue.slice(decimalIndex, -1).length

  //   if (
  //     counter.innerText.length - decimalLength <= 0
  //   ) {
  //     counter.innerText = counter.innerText + counter.closest('.fac-nc-ergebnis').dataset.numberValue.slice(decimalIndex, fullLength)
  //   }
  // })
  // if (counters) {
  //   counters.forEach(counter => {
  //     mObserver.observe(counter, {
  //       childList: true
  //     })
  //   })
  // }
  // // #endregion

  // #region Diolog  
  const buttonsPNC = document.querySelectorAll('.fac-pnc')

  buttonsPNC.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault()

      document.querySelector(`#${button.dataset.type}`).showModal()
    })
  })

  const dialogCloseElements = document.querySelectorAll('dialog .dialog-close')

  dialogCloseElements.forEach(close => {
    close.addEventListener('click', e => {
      e.preventDefault()

      document.querySelector(`#${close.dataset.target}`).close()
    })
  })
  // #endregion

  // #region Scroll Fix
  // When the user scrolls down 150px from the top of the document, show the button
  window.onscroll = function () {
    scrollFunction()
  }

  function scrollFunction() {
    if (
      document.body.scrollTop > 150 ||
      document.documentElement.scrollTop > 150
    ) {
      document.getElementById('main-header').classList.add('et-fixed-header')
    } else {
      document.getElementById('main-header').classList.remove('et-fixed-header')
    }
  }
  // #endregion

  const countersPNC = document.querySelectorAll('.fac-pnc-number h3')
  const countersSNC = document.querySelectorAll('.fac-snc-number h3')

  const customNumberCounterObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const counter = entry.target
          const parent = counter.closest('.fac-pnc')
          let digits = 2

          if(parent && parent.dataset.type === 'anteil') digits = 4

          const number = parseFloat(counter.innerText.match(/[0-9]*\.?[0-9]+/g))

          const duration = 2000 // Animation duration in milliseconds
          const updateInterval = 50 // Update interval in milliseconds
          const frameCount = Math.ceil(duration / updateInterval) // Number of frames (rounded up)
          let currentNumber = 0 // Start with 0 as the initial number
          let frame = 0 // Current frame count

          const increment = (number - currentNumber) / frameCount // Amount to increment in each frame

          const animationInterval = setInterval(() => {
            if (frame === frameCount - 1) {
              currentNumber = number // Set currentNumber directly to the targetNumber on the last frame
              clearInterval(animationInterval) // Stop the animation after reaching the last frame
            } else {
              currentNumber += increment // Increment the current number
            }

            counter.innerText = counter.innerText.replace(
              /[0-9]*\.?\,?[0-9]+/g,
              new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: digits,
                maximumFractionDigits:
                  getDecimalPlaces(number) >= digits ? getDecimalPlaces(number) : digits
              }).format(currentNumber)
            ) // Update the element with the rounded decimal number

            frame++ // Increment the frame count
          }, updateInterval)

          customNumberCounterObserver.unobserve(counter)
        }
      })
    },
    {
      rootMargin: '150px 0px 150px 0px'
    }
  )

  countersPNC.forEach(counter => {
    customNumberCounterObserver.observe(counter)
  })
  countersSNC.forEach(counter => {
    customNumberCounterObserver.observe(counter)
  })
})

function getDecimalPlaces (num) {
  const decimalPart = String(num).match(/\.\d+/)
  return decimalPart ? decimalPart[0].length - 1 : 0
}

function closeDialog(target) {
  document.querySelector(`#${target}`).close()
}
